// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2UPST","description":"MealItem_description__2qraz","price":"MealItem_price__3EaM5"};